// extracted by mini-css-extract-plugin
export var Button = "Button-module--Button--37c2k";
export var ButtonRed = "Button-module--Button--red--1N5lP";
export var red = "Button-module--red--dZNpw";
export var green = "Button-module--green--2QOR9";
export var blue = "Button-module--blue--3XCXo";